import { render, staticRenderFns } from "./wan2.vue?vue&type=template&id=1e33c38a&scoped=true&"
import script from "./wan2.vue?vue&type=script&lang=js&"
export * from "./wan2.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=1e33c38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e33c38a",
  null
  
)

export default component.exports